import { Subscribe } from "@react-rxjs/core"
import { useTranslation } from "react-i18next"

import { SimpleViewLayout } from "@/App/Equities/mobile/layout"
import { RootPath } from "@/App/Equities/mobile/paths"
import { ErrorBoundary, Loading } from "@/App/Equities/shared/components"
import { useInstrumentMap } from "@/App/Equities/shared/services/instruments"
import { useClosePositionResponse } from "@/App/Equities/shared/services/orders"
import { usePositions } from "@/App/Equities/shared/services/positions"

import { List } from ".."
import { MOBILE_POSITIONS_PAGE_LOCATORS } from "./locators"
import { PositionListItem } from "./PositionListItem"
import { PositionsHeader } from "./PositionsHeader"

export const Positions = () => {
  const { t } = useTranslation()
  return (
    <SimpleViewLayout
      data-testid=""
      routePattern={RootPath.positions}
      header={<PositionsHeader />}
    >
      <ErrorBoundary fallback={<div>{t("errorLoadingPositions")}</div>}>
        <Subscribe fallback={<Loading />}>
          <PositionsList />
        </Subscribe>
      </ErrorBoundary>
    </SimpleViewLayout>
  )
}

const PositionsList = () => {
  useClosePositionResponse()
  const positions = usePositions()
  const instruments = useInstrumentMap(
    positions.map((position) => position.symbol).join(","),
  )
  const enrichedPositions = positions.map((position) => ({
    ...position,
    instrument: instruments.get(position.symbol),
  }))

  return (
    <List data={enrichedPositions} keyField="symbol">
      {(position, index) => (
        <PositionListItem
          {...position}
          data-testid={`${MOBILE_POSITIONS_PAGE_LOCATORS.main}.row.${index}`}
        />
      )}
    </List>
  )
}
